<template>

  <html>
  
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
    <meta name="mobile-web-app-capable" content="yes" />
    <meta name="apple-mobile-web-app-capable" content="yes" />
    <link rel="icon" type="image/png" href="favicon.png" />
    <title>Restó APP</title>
  </head>
  
  <body  style="background-color: white;">
  
      <header class="px-3 py-2 text-white" style=" background: linear-gradient(79.95deg, #297C4B 42.76%, #4BE289 92.44%);;">
        <div class="container text-center" >
          <h1 >MENÚ DISPONIBLE</h1>
          <h3 >{{ nombre }}</h3>
        </div>
      </header>
     
    <div style="padding-left: 10px;padding-right: 10px;" >
     
      <template v-if="!sinCategoria">
  <div class="card" v-for="(apartado, index) in apartados" :key="apartado.id" style="margin-top: 40px;background-color: #FFFBEB;">
    <div class="card-body header-expand">
      <div class="accordion accordion-flush">
        <div class="accordion-item" style="background-color: #FFFBEB;">
          <!-- Usamos un botón para cubrir todo el encabezado -->
          <button class="accordion-header-base" 
            :id="'heading' + index"
            @click="toggleAccordion(index,apartados)"
            style="width: 100%; display: flex; justify-content: space-between; align-items: center; background: none; border: none; padding: 5px;">
            <span v-if="!modoEdit" class="titulo-categoria">
              
              {{ apartado.nombre }}</span>


              
            <input v-else v-model="apartado.nombre" class="titulo-categoria editar" @input="debouncedInputChange(apartado, 'nombreApartado')" @click.stop  />
          
          
            <span class="accordion-icon" style="float: right;">

<template v-if="apartado.expandido">
                      <!-- SVG para cuando está expandido -->
                      <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1.00004 6.77002L5.77004 2.00002L10.54 6.77002" stroke="#595959" stroke-width="1.5" stroke-miterlimit="10"/>
                      </svg>
                  </template>
                  <template v-else>
                      <!-- SVG para cuando no está expandido -->
                      <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1.00004 0.999999L5.77004 5.77L10.54 1" stroke="#595959" stroke-width="1.5" stroke-miterlimit="10"/>
                      </svg>
                  </template>

</span> <!-- Flecha hacia abajo -->
          
          </button>
          <div :id="'collapse' + index" class="accordion-collapse collapse" :class="{ show: apartado.expandido }">
           
           
           
           
           
<div v-for="(subcategoria, index2) in apartado.subcategorias" :key="subcategoria.id" style="margin-top: 20px;" >
  
  
  
  
  
  
  
  <div class="accordion accordion-flush">
        <div class="accordion-item" style="background-color: #FFFBEB;">
          <!-- Usamos un botón para cubrir todo el encabezado -->
          <button class="accordion-header-base" 
            :id="'heading' + index2"
            @click="toggleAccordion(index2,apartado.subcategorias)"
            style="width: 100%; display: flex; justify-content: space-between; align-items: center; background: none; border: none; padding: 5px;">
            <span v-if="!modoEdit" class="titulo-categoria">{{ subcategoria.nombre }}</span>
          

            <div v-else>
  <div class="input-button-container">
    <input  v-model="subcategoria.nombre" class="titulo-categoria editar" @input="debouncedInputChange(subcategoria, 'nombreSubcategoria')" @click.stop  />
  </div>
</div>

          
          
            <span class="accordion-icon" style="float: right;">

<template v-if="subcategoria.expandido">
                      <!-- SVG para cuando está expandido -->
                      <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1.00004 6.77002L5.77004 2.00002L10.54 6.77002" stroke="#595959" stroke-width="1.5" stroke-miterlimit="10"/>
                      </svg>
                  </template>
                  <template v-else>
                      <!-- SVG para cuando no está expandido -->
                      <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1.00004 0.999999L5.77004 5.77L10.54 1" stroke="#595959" stroke-width="1.5" stroke-miterlimit="10"/>
                      </svg>
                  </template>

</span> <!-- Flecha hacia abajo -->
          
          </button>
          <div :id="'collapse' + index" class="accordion-collapse collapse" :class="{ show: subcategoria.expandido }">
           
           
           
            <div class="separator"></div>




            <div class="row item-menu-precio " v-for="(plato) in subcategoria.platos" :key="plato.id" >
    <div class="col-7 item-plato pe-0  d-flex d-flex align-items-center " >
   
      <span>{{ plato.nombre }}</span>
    <!--    <textarea v-else v-model="plato.nombre" class="editar" rows="2" style="width: 100%;border: none;overflow: hidden;" @input="debouncedInputChange(plato,'editarPlato')">
      
      </textarea> -->



    </div>
<div class="col-3 precio-item-plato pe-0 ps-0 d-flex align-items-center">
 
  $
  <span> {{ formatPrecio(plato.precio) }}</span>
  <!-- <input v-else type="number" style="width: 100px;" v-model="plato.precio" 
  
  class="editar" @input="debouncedInputChange(plato,'editarPlato')" /> -->


</div>
<div class="col-2 pe-0 ps-0 d-flex justify-content-center d-flex align-items-center">
  <div class="circle" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="platoModal = plato" >+</div>

    
  <button v-if="modoEdit" type="button" 
  
  class="btn btn-outline btn-sm" style="
  color:#198754;
  max-height: 30px;margin-left: 5px;" @click.stop>
  
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16"
    @click="confirmarEliminarPlato(plato)"
    >
  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
</svg></button>

</div>

</div>

<button v-if="modoEdit && subcategoria.expandido" type="button" class="btn btn-success btn-sm" style="max-height: 35px;"   @click.stop @click="agregarPlato(subcategoria.id)"  >Agregar plato</button>
  

          </div>
        </div>
      </div>
  
  
  
  
  
  
            </div>



          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  
  
  
  
  <template v-if="sinCategoria" >
  
    <div class="card" v-for="(apartado, index) in apartados[0].subcategorias" :key="apartado.id" style="margin-top: 40px;background-color: #FFFBEB;">
    <div class="card-body header-expand">
      <div class="accordion accordion-flush">
        <div class="accordion-item" style="background-color: #FFFBEB;">
          <!-- Usamos un botón para cubrir todo el encabezado -->
          <button class="accordion-header-base" 
            :id="'heading' + index"
            @click="toggleAccordion(index,apartados[0].subcategorias)"
            style="width: 100%; display: flex; justify-content: space-between; align-items: center; background: none; border: none; padding: 5px;">
            <span v-if="!modoEdit" class="titulo-categoria">{{ apartado.nombre }}
            </span>

            <div v-else>
  <div class="input-button-container">
    <input v-model="apartado.nombre" 
    class="titulo-categoria editar" 
    style="max-width: 200px;" 
    @input="debouncedInputChange(apartado, 'nombreSubcategoria')" @click.stop />
 </div>
</div>

          
            <span class="accordion-icon" style="float: right;">

<template v-if="apartado.expandido">
                      <!-- SVG para cuando está expandido -->
                      <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1.00004 6.77002L5.77004 2.00002L10.54 6.77002" stroke="#595959" stroke-width="1.5" stroke-miterlimit="10"/>
                      </svg>
                  </template>
                  <template v-else>
                      <!-- SVG para cuando no está expandido -->
                      <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1.00004 0.999999L5.77004 5.77L10.54 1" stroke="#595959" stroke-width="1.5" stroke-miterlimit="10"/>
                      </svg>
                  </template>

</span> <!-- Flecha hacia abajo -->
          
          </button>
          <div :id="'collapse' + index" class="accordion-collapse collapse" :class="{ show: apartado.expandido }">
           
           
           
           
            <div class="separator"></div>






            <div class="row item-menu-precio " v-for="(plato) in apartado.platos" :key="plato.id" >
    <div class="col-7 item-plato pe-0  d-flex d-flex align-items-center " >
   
      <span >{{ plato.nombre }}</span>
     <!--   <textarea v-else v-model="plato.nombre" class="editar" rows="2" style="width: 100%;border: none;overflow: hidden;" @input="debouncedInputChange(plato,'editarPlato')">
      
      </textarea> -->



    </div>
<div class="col-3 precio-item-plato pe-0 ps-0 d-flex align-items-center">
 
  $
  <span > {{ formatPrecio(plato.precio) }}</span>
 <!--  <input v-else type="number" style="width: 100px;" v-model="plato.precio" 
  
  class="editar" @input="debouncedInputChange(plato,'editarPlato')" /> -->


</div>



 
<div  class="col-2 pe-0 ps-0 d-flex justify-content-center d-flex align-items-center">
  <div class="circle" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="platoModal = plato" id="button-open-modal" >+</div>
  
  <button v-if="modoEdit" type="button" 
  
  class="btn btn-outline btn-sm" style="
  color:#198754;
  max-height: 30px;margin-left: 5px;" @click.stop>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16"
    @click="confirmarEliminarPlato(plato)"
    >
  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
</svg></button>

</div>




</div>




<button v-if="modoEdit && apartado.expandido"  type="button" class="btn btn-success btn-sm" style="max-height: 35px;"   @click.stop @click="agregarPlato(apartado.id)"  >Agregar plato</button>
  





          </div>
        </div>
      </div>
    </div>
  </div>
  
  </template>
  
  
  
  
  
  
  
  
  
  <!-- Modal -->
  <div class="modal fade" id="exampleModal" tabindex="-1" data-bs-backdrop="static"  aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" style="    background: transparent;border: none;">
      <div class="modal-content" style="    background: transparent;border: none;">
        
        <div class="modal-body" style="    background: transparent;border: none;">

          <img v-if="guardandoNuevoPlato"  src="../assets/loading.gif" class="card-img-top" alt="Imagen del plato">
 


          <div v-else class="card" :style="{ minWidth: '18rem', borderRadius: platoModal.foto == 'sin-imagen.jpg' ? '10px' : '0' }" >
  

          <div v-if="!modoEdit" >
         
          <img v-if="platoModal.foto !== 'sin-imagen.jpg'" :src="imageUrl(platoModal.foto)" class="card-img-top" alt="Imagen del plato">
      <div v-else class="text-center">
  
        <div class="px-3 py-2 text-white" style=" background: linear-gradient(79.95deg, #297C4B 42.76%, #4BE289 92.44%); border-top-left-radius: 10px;border-top-right-radius: 10px;">
        <div class="container text-center" >
          <h3 >{{ nombre }}</h3>
        </div>
      </div>
  
      
      </div>

    </div>

    <template v-else >

      
  <div v-if="!editandoImagen" class="image-container" @click="triggerFileInput">
    <img :src="imageUrl(platoModal.foto)" class="card-img-top" alt="Imagen del plato">
  </div>
  <div v-else class="image-container" >
    <img src="../assets/loading.gif" class="card-img-top" alt="Imagen del plato">
 
  </div>
  <input type="file" ref="fileInput" style="display: none" @change="cambiarImagen" accept="image/jpg, image/jpeg, image/png">
</template>




       
  
    <div class="card-body">
     <div class="row">


      <div v-if="!modoEdit" class="col-8 text-start titulo-modal">
        <span >  {{ platoModal.nombre }}</span>

      </div>
      <div v-else class="col-8">
   
      <input 
        placeholder="Nombre"
        type="text" 
        @input="capitalizeFirstLetterPlatoNombre(platoModal)"
        style="padding: 0px; text-align: left;margin:0px" 
        v-model="platoModal.nombre" 
               class="editar"  />
  
              </div>


      <div class="col-4 text-end precio-modal">
      
    <span v-if="!modoEdit"> $ {{ formatPrecio(platoModal.precio) }}</span>
    <div v-else style="display: flex; justify-content: flex-end; align-items: center;">
        <span>$</span>
        <input type="number" style="width: 80px; margin-left: 5px;" v-model="platoModal.precio" 
               class="editar"  />
    </div>
</div>
    </div>
     
    <div class="row" style="margin-top: 20px;">
      <div class="col-12">
        <p class="text-start text-justify descripcion-modal">
          <span v-if="!modoEdit">  {{ platoModal.descripcion }}</span>

          <input v-else v-model="platoModal.descripcion" 
          
        @input="capitalizeFirstLetterPlatoDesc(platoModal)"
  placeholder="Descripción"
          class="editar"    />
          



        </p>
      </div>
    </div>
  
    <div class="row" style="margin-top: 20px;"  v-if="columnasIngredientes.length>0" >
      <div class="col-12 text-start titulo-ingredientes">
        Ingredientes
      </div>
    </div>
  
    <div class="container" v-if="!modoEdit" style="margin-top: 20px;">
      <div class="row">
          <!-- Itera sobre cada columna -->
          <div class="col-sm" v-for="(columna, index) in columnasIngredientes" :key="`columna-${index}`">
              <!-- Itera sobre cada ingrediente en la columna -->
              <div v-for="(ingrediente, i) in columna" :key="`ingrediente-${i}`" class="ingrediente-item">
                  <span class="dot">•</span>
                  <span class="ingrediente-text">{{ ingrediente }}</span>
              </div>
          </div>
      </div>
  </div>


  <div class="container" v-else> 
  <textarea  v-model="platoModal.ingredientes" 
  
  @input="capitalizeFirstLetterPlatoIngredientes(platoModal)"
  placeholder="Ingredientes"
  class="editar" rows="2" style="width: 100%;border: none;overflow: hidden;" >
      
    </textarea>
  </div>

  
  <div class="row" style="margin-top: 20px;" v-if="platoModal.porciones" >
      <div class="col-12 text-start texto-porciones">

        Porciones
  <span v-if="!modoEdit"> {{ platoModal.porciones }}</span>
  <input v-else type="number" style="width: 50px;" v-model="platoModal.porciones" 
  
  class="editar" />
         personas
      </div>
    </div>

    <div class="row" style="margin-top: 20px;"  v-else-if="modoEdit" >
      <div class="col-12 text-start texto-porciones">

        Porciones
  <input  type="number" style="width: 50px;" v-model="platoModal.porciones" 
  
  class="editar"  />
         personas
      </div>
    </div>


    
  
    <div v-if="!modoEdit" class="row" style="margin-top: 20px;">
  
      <div class="col-12">
      <button type="button" class="btn btn-sm " 
      data-bs-dismiss="modal" style="    height: 30px;background-color: #04B74D;color:white">CERRAR</button>
    </div> 
  
  </div>

  <div  v-else >
    <div   class="row" style="margin-top: 20px;">
  <div class="col-12">
  <button type="button" class="btn btn-sm " 
   style="min-width: 150px;height: 30px;background-color: #04B74D;color:white" @click="guardarPlato()" >GUARDAR</button>
</div> 

</div>
<div   class="row" style="margin-top: 20px;"></div>
<div class="col-12">
<button type="button" class="btn btn-sm " 
      data-bs-dismiss="modal" id="cerrarModalManual" style=" min-width: 150px;   height: 30px;background-color: gray;color:white">CANCELAR</button>
    </div> 


</div>


  </div>
  </div>
  </div>
      </div>
    </div>
  </div>
  
  </div>

  <div 
 data-bs-toggle="modal" 
 data-bs-target="#exampleModal" 
id="button-open-modal-manual" style="display: none;"></div>
<PopUpConfirmacionNuevoHtml :show="showEliminar" @close="showEliminar = false" @confirmar="eliminarPlato();confirmacion_estado_html = false;">
          <template #body>
            <p>¿Seguro que desea eliminar el plato ?  </p>
            <p>{{ platoEliminar.nombre }} </p>
          </template>
        </PopUpConfirmacionNuevoHtml>
        <PopUpAceptar :show="showPlatoAgregado" @close="showPlatoAgregado = false"  @confirmar="cerrarMensajePlatoAgregado()" >
          <template #body>
            <p>{{ messagePlatoAgregado }} </p>
          </template>
        </PopUpAceptar>



        <PopUpMenuInicialHtml :show="showAvisoInicial" @close="showAvisoInicial = false" @confirmar="handleConfirmarAvisoInicial">
          <template #body>
            <p>Menú con todos los items disponibles para el dia de hoy {{ fechaActual }} </p>
            <p>Aquí también podrás indicar si el item está disponible, suspendido temporalmente o eliminado del menú. El menú debe estar siempre actualizado porque en base a este menú es que el cliente hará sus pedidos.  </p>
          </template>
        </PopUpMenuInicialHtml>


  </body>
  
  </html>
  </template>
  
  <script>
  import axios from "axios";
  import PopUpConfirmacionNuevoHtml from "../components/PopUpConfirmacionNuevoHtml.vue";
  import PopUpAceptar from "../components/PopUpAceptar.vue";
  import PopUpMenuInicialHtml from "../components/PopUpMenuInicialHtml.vue";
  

  export default {
    name: "Menu",
  components: { PopUpConfirmacionNuevoHtml,PopUpAceptar,PopUpMenuInicialHtml },
    data: function () {
      return {
        showPlatoAgregado:false,
        messagePlatoAgregado:"",
        showEliminar:false,
        platoEliminar:null,
        timeout:null,
        modoEdit:false,
        editandoImagen:false,
        restaurante: Object,
        apartados: [],
        sinCategoria: false,
        nombre: "",
        error: false,
        error_msg: "",
        success: false,
        success_msg: "",
        stock:null,
        platoModal:{},
        reservasPendiente:null,
        isLogin:false,
        guardandoNuevoPlato:false,
        showAvisoInicial:false,
        fechaActual: '',
      };
    },
    computed: {
      avisoInicial() {
        return this.$route.query.aviso=="true";
    },
    apartadosConPlatos() {
      return this.apartados.filter(apartado => apartado.platos && apartado.platos.length > 0);
    }, 
      columnasIngredientes() {
        if(!this.platoModal.ingredientes) return [];
          const ingredientes = this.platoModal.ingredientes.split(',');
          const columnas = [[], [], []]; // Prepara tres listas para tres columnas
          ingredientes.forEach((ingrediente, index) => {
              columnas[index % 3].push(ingrediente.charAt(0).toUpperCase() + ingrediente.slice(1)); // Distribuye los ingredientes equitativamente
          });
          return columnas;
      }
  },
    methods: {

      triggerFileInput() {
      this.$refs.fileInput.click();
    },
    cambiarImagen(event) {
      this.editandoImagen=true;
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.platoModal.foto = e.target.result;
          if (this.platoModal.id != null) {
            axios.post("/editar-plato/"+this.platoModal.id, this.platoModal).then((data) => {
             
              this.platoModal=data.data;
              this.editandoImagen=false;


                this.apartados.forEach(apartado => {
  apartado.subcategorias.forEach(subcategoria => {
    subcategoria.platos.forEach((plato, index) => {
      if (plato.id == this.platoModal.id) {
        subcategoria.platos[index] = this.platoModal;
      }
    });
  });
});
          

            })
          }else{

            axios.post("/agregar-imagen-plato", 
            {foto:e.target.result}).then((data) => {
            this.platoModal.foto = data.data.nombreFichero;
            this.editandoImagen=false;
              })

          
          }
        };
        reader.readAsDataURL(file);
      }
    },
    agregarPlato(id){
      this.platoModal={idSubcategoriaPlato:id};
      document.getElementById('button-open-modal-manual').click();
    },
      toggleAccordion(index,lista) {
        lista.forEach((item,i) => {
        if (i === index) {
          item.expandido = !item.expandido;
        } else {
          item.expandido = false;
        }
      
      });
    },
    confirmarEliminarPlato(plato){
      this.showEliminar=true;
      this.platoEliminar=plato;
      
    },eliminarPlato(){
     
    axios.delete("/eliminar-plato/"+this.platoEliminar.id).then(() => {
      this.showEliminar=false;
      this.cargarApartados();
      document.getElementById('cerrarModalManual').click();
          })
      
    },

    cerrarMensajePlatoAgregado(){
      document.getElementById('cerrarModalManual').click();
      this.showPlatoAgregado=false;
    },
    guardarPlato(){
      
      if(this.platoModal.id){
        axios.post("/editar-plato/"+this.platoModal.id, this.platoModal).then(() => {
          this.messagePlatoAgregado="Plato actualizado con exito!"
      this.showPlatoAgregado=true;

          })
      }else{
        this.guardarPlatoNuevo();
      }
     
    },

    guardarPlatoNuevo(){
      this.guardandoNuevoPlato=true;
     axios.post("/agregar-plato/"+this.platoModal.idSubcategoriaPlato,this.platoModal).then(() => {
      this.guardandoNuevoPlato=false;
      this.messagePlatoAgregado="Plato agregado con exito!"
      this.showPlatoAgregado=true;
      this.cargarApartados();
      })
    },
      handleInputChange(data,cambioField) {
        if(data.id==undefined){
          return;
        }
        // Lógica a ejecutar cuando el input cambia después de 1 segundo
        if(cambioField=="nombreApartado"){
          axios.post("/editar-apartado/"+data.id, {nombre:data.nombre});
        }else if(cambioField=="nombreSubcategoria"){
          axios.post("/editar-subcategoria/"+data.id, {nombre:data.nombre});
        }else if(cambioField=="editarPlato"){
          axios.post("/editar-plato/"+data.id, data);
        }
        
      },
      capitalizeFirstLetter(apartado) {
      if (apartado.nombre && apartado.nombre.length > 0) {
        apartado.nombre = apartado.nombre.charAt(0).toUpperCase() + apartado.nombre.slice(1);
      }
    },
      debouncedInputChange(apartado,cambioField) {
        this.capitalizeFirstLetter(apartado)
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.handleInputChange(apartado,cambioField);
        }, 1000);
      },
      abrirApartado(apartado){
        apartado.expandido=false
      },
      formatPrecio(value) {
        // Convertimos el valor a un número flotante
        let num = parseFloat(value);
          if (isNaN(num)) return value; // Retorna el valor original si no es un número
  
          // Convertimos el número a un string y separamos la parte entera de la decimal
          let parts = num.toFixed(0).split('.');
          // Reemplazamos cada tres dígitos en la parte entera con un punto como separador de miles
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          // Unimos la parte entera y decimal con una coma
          return parts.join(',');
      },
      imageUrl(foto) {
        if(this.editandoImagen){
          return
        }
        return `${axios.defaults.baseURL}/imagen/${foto}`;
      },
      capitalizeFirstLetterPlatoDesc(platoModal){
        if (platoModal.descripcion && platoModal.descripcion.length > 0) {
        platoModal.descripcion = platoModal.descripcion.charAt(0).toUpperCase() + platoModal.descripcion.slice(1);
      }
      },
      capitalizeFirstLetterPlatoNombre(platoModal){
        if (platoModal.nombre && platoModal.nombre.length > 0) {
        platoModal.nombre = platoModal.nombre.charAt(0).toUpperCase() + platoModal.nombre.slice(1);
      }
      },
      capitalizeFirstLetterPlatoIngredientes(platoModal){
        if (platoModal.ingredientes && platoModal.ingredientes.length > 0) {
        platoModal.ingredientes = platoModal.ingredientes.charAt(0).toUpperCase() + platoModal.ingredientes.slice(1);
      }
      },
      cargarApartados(){
        let paramsQuery="";
        if(this.$route.query.editar && this.$route.query.key){
          paramsQuery="?keyEditMenu="+this.$route.query.key;
        }


  axios.get("/obtener-menu-apartados/"+this.$route.params.id+paramsQuery).then((data) => {
  this.sinCategoria=data.data.sinCategoria;
  this.modoEdit=data.data.modoEdicionMenu;
  if(!this.sinCategoria){
    this.apartados= data.data.apartados.filter(apartado => apartado.nombre !== "SIN CATEGORIA");
  }else{
    this.apartados=data.data.apartados;
  }
    this.nombre=data.data.nombre;
    })
  },
  mostrarAvisoInicial(){
    if(this.avisoInicial){
      this.showAvisoInicial=true;
    }

  },
  obtenerFechaActual() {
      const hoy = new Date();
      const opciones = { year: 'numeric', month: 'long', day: 'numeric' };
      this.fechaActual = hoy.toLocaleDateString('es-ES', opciones);
    },
  handleConfirmarAvisoInicial(e){
    this.showAvisoInicial=false;
    this.confirmacion_estado_html = false;

    if(e){
      localStorage.setItem('omitirAvisoMenuInicial', 'true');
    }
  }
  
    },
   
    
    beforeMount() {
      this.cargarApartados();

      if (localStorage.getItem('omitirAvisoMenuInicial') === null) {
        this.obtenerFechaActual(); 
        this.mostrarAvisoInicial();

      }
    },
  };
  </script>
  
  <style scoped>
  @import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
  @import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");
  body {
      font-family: Arial, sans-serif;
      background-color: #f8f9fa;
      margin: 0;
    }
   
  .item-menu-precio{
    background-color: white;
    -webkit-box-shadow: 0px 0px 16px -10px rgba(0,0,0,0.58);
  -moz-box-shadow: 0px 0px 16px -10px rgba(0,0,0,0.58);
  box-shadow: 0px 0px 16px -10px rgba(0,0,0,0.58);
   border-radius: 20px; /* Ajusta este valor para cambiar la redondez */
     padding-top: 2px;
     padding-bottom: 2px;
     margin: 10px;
  }
  .list-group-item{
  
  }
  
  .separator {
      height: 2px; /* Altura del separador */
      background: linear-gradient(to right, transparent, #cccccc, transparent);
      margin: 20px 0;
  }
  
          
  
  .titulo-categoria{
    font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  
  }
  
  
  .titulo-subcategoria{
    padding-left: 15px;
    font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  
  }
  
  .item-plato{
    font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  
  
  }
  
  .precio-item-plato{
    font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  
  }
  .circle {
    cursor: pointer;
    width: 19px;                /* Ancho del círculo */
    height: 20px;               /* Alto del círculo */
    background-color:#04B74D;   /* Color de fondo del círculo (verde) */
    border-radius: 50%;          /* La clave para hacerlo redondo */
    color: white;                /* Color del texto (blanco) */
    font-size: 21px;             /* Tamaño del signo más */
    text-align: center;          /* Alinea el texto horizontalmente */
    line-height: 20px;          /* Alinea el texto verticalmente */
    font-family: Arial, sans-serif; /* Fuente del texto */
    
  }
  
  .titulo-modal{
    font-family: Inter;
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  
  }
  
  .precio-modal{
    font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  padding-left: 0px;
  }
  
  .descripcion-modal{
    font-family: Inter;
  font-size: 16px;
  font-weight: 300;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  padding-right: 0px;
  
  }
  
  .ingrediente-item {
      display: flex;
      align-items: center;
  }
  
  .dot {
      margin-right: 8px; /* Ajusta el espacio según necesites */
      font-size: 20px; /* Ajusta el tamaño del punto según necesites */
      /* Ajusta el color y otros estilos del punto si es necesario */
  }
  
  .ingrediente-text{
    font-family: Inter;
  font-size: 13px;
  font-weight: 300;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  
  }
  
  .texto-porciones{
    font-family: Inter;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  
  }
  
  .titulo-ingredientes{
    font-family: Inter;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  
  }
  
  input.editar{
    background: transparent;
      border: none;
  }
  
  .accordion-header-base{
   
    width: 100%; 
    display: flex; 
    justify-content: space-between; 
    align-items: center; 
    background: none; 
    border: none; 
    padding: 5px;
  }
  
  .header-expand{
    padding: 5px;
  }

  .input-button-container {
  display: flex;
  align-items: center; /* Alinea los elementos verticalmente al centro */
}

.input-button-container input {
  margin-right: 10px; /* Añade un margen a la derecha del input para separar los elementos */
}
  </style>
  